import {POAbstractOrgUnit} from '@obj-models/POAbstractOrgUnit';

export default class POOrgUnit extends POAbstractOrgUnit {
  static type = 'OrgUnit';
  type = POOrgUnit.type;
}
